import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'content'];

  connect() {
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.triggerTarget.addEventListener('mouseenter', this.show);
    this.triggerTarget.addEventListener('mouseleave', this.hide);
    this.triggerTarget.addEventListener('focus', this.show);
    this.triggerTarget.addEventListener('blur', this.hide);
  }

  disconnect() {
    this.triggerTarget.removeEventListener('mouseenter', this.show);
    this.triggerTarget.removeEventListener('mouseleave', this.hide);
    this.triggerTarget.removeEventListener('focus', this.show);
    this.triggerTarget.removeEventListener('blur', this.hide);
  }

  show(event) {
    if (event) {
      event.preventDefault();
    }
    this.contentTarget.classList.remove('hidden');
  }

  hide() {
    this.contentTarget.classList.add('hidden');
  }
}
